export default __webpack_public_path__ + "static/linkedin-image-cfc92b4817f502ee5e3d2971e85f5341.png";